import { createAppKit } from "@reown/appkit/react";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { SolanaAdapter } from "@reown/appkit-adapter-solana";
import { base, solana, defineChain } from "@reown/appkit/networks";
import { WagmiProvider } from "wagmi";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();

const projectId = "1ff900ac02e3cf7b987bb259be572983";
const metadata = {
  name: "Web3Modal",
  description: "Web3Modal Example",
  url: "https://web3modal.com",
  icons: ["https://avatars.githubusercontent.com/u/37784886"],
};

// Custom peaq network (EVM-compatible, chain ID 3338) defined for AppKit.
const peaq = defineChain({
  id: 3338,
  caipNetworkId: "eip155:3338",
  chainNamespace: "eip155",
  name: "peaq",
  nativeCurrency: { name: "peaq Token", symbol: "PEAQ", decimals: 18 },
  rpcUrls: {
    default: { http: ["https://peaq-rpc.publicnode.com"] },
  },
  blockExplorers: {
    default: { name: "peaq Explorer", url: "https://explorer.peaq.network" },
  },
});

// EVM networks handled by the wagmi adapter.
const evmNetworks = [peaq, base];
// Full set passed to AppKit: EVM networks + Solana mainnet. AppKit's modal is
// multichain, so a single "Connect Wallet" button lists EVM AND Solana wallets.
const networks = [peaq, base, solana];

const wagmiAdapter = new WagmiAdapter({
  networks: evmNetworks,
  projectId,
});

const solanaAdapter = new SolanaAdapter();

createAppKit({
  adapters: [wagmiAdapter, solanaAdapter],
  networks,
  projectId,
  metadata,
  // Verification is read-only and chain-agnostic (the backend reads balances
  // from its own RPCs by address), so don't force users onto a supported
  // network — let any connected wallet proceed straight to verification.
  allowUnsupportedChain: true,
  features: {
    analytics: true,
    onramp: true,
  },
  featuredWalletIds: [
    "c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96",
  ],
});

export const wagmiConfig = wagmiAdapter.wagmiConfig;

export function ContextProvider({ children }) {
  return (
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </WagmiProvider>
  );
}
